import { render, staticRenderFns } from "./teamsActions.vue?vue&type=template&id=1c1a8eae&scoped=true&"
import script from "./teamsActions.vue?vue&type=script&lang=js&"
export * from "./teamsActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1a8eae",
  null
  
)

export default component.exports